/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ContractType =
  | 'CORPORATE'
  | 'INDIVIDUAL'
  | 'UNKNOWN';

export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type SettingsPageSideMenuContractFragment = { contractType: Types.ContractType, paymentMethod: Types.PaymentMethod };

export type SettingsPageSideMenuViewerFragment = { id: string, myStoryUrl: string | null, hasLineActivationProvider: boolean, profile: { name: string, avatar: any, reviewScore: number }, autoPostKartePlannerComment: { available: boolean }, attackListSender: { available: boolean }, staff: { role: Types.StaffRole } };

export type SettingPageSideMenuSubQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingPageSideMenuSubQuery = { entrances: Array<{ guid: string }> };

export const SettingsPageSideMenuContractFragmentDoc = gql`
    fragment SettingsPageSideMenuContract on Contract {
  contractType
  paymentMethod
}
    `;
export const SettingsPageSideMenuViewerFragmentDoc = gql`
    fragment SettingsPageSideMenuViewer on Viewer {
  id
  myStoryUrl
  profile {
    name
    avatar
    reviewScore
  }
  autoPostKartePlannerComment {
    available
  }
  attackListSender {
    available
  }
  hasLineActivationProvider
  staff {
    role
  }
}
    `;
export const SettingPageSideMenuSubDocument = gql`
    query SettingPageSideMenuSub {
  entrances {
    guid
  }
}
    `;

/**
 * __useSettingPageSideMenuSubQuery__
 *
 * To run a query within a Vue component, call `useSettingPageSideMenuSubQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingPageSideMenuSubQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingPageSideMenuSubQuery();
 */
export function useSettingPageSideMenuSubQuery(options: VueApolloComposable.UseQueryOptions<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>(SettingPageSideMenuSubDocument, {}, options);
}
export function useSettingPageSideMenuSubLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>(SettingPageSideMenuSubDocument, {}, options);
}
export type SettingPageSideMenuSubQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingPageSideMenuSubQuery, SettingPageSideMenuSubQueryVariables>;